import { MessageBox, Loading } from 'element-ui';
import { Manage_internet_service } from "../services/Manage_internet_service"
import router from "../router/router"
import moment from "moment"
import Cookie from "cookies-js"
const month_th = ['มกราคม','กุมภาพันธ์','มีนาคม','เมษายน','พฤษภาคม','มิถุนายน','กรกฎาคม','สิงหาคม','กันยายน','ตุลาคม','พฤศจิกายน','ธันวาคม']
const state = {
    user_id : null,
    provider_id : null,
    provider_type : null,
    provider_type_th : null,
    provider_name : null,
    file_path : null,
    file_type : null,
    lists : [],
    details : null,
    prepares :[],
    errors : [],
    missings : [],
    recent : null,
    monthly : null,
    formdata : null,
    histories : null,
    name : null,
    forward_path : null,
    total : 0,
    loading : false,
    month_title : '',
    preview_data: {
        count: {},
        average: 0,
        percent: {}
    },
    regulate_list:[],
    broadband_schema_en : [
        'promotion_code',
        'promotion_name_th',
        'promotion_name_en',
        'promotion_technology',
        'promotion_type',
        'start_sale_date',
        'end_sale_date',
        'start_service_date',
        'end_service_date',
        'service_status',
        'promotion_price',
        'download_speed',
        'upload_speed',
        'content_service_th',
        'content_service_en',
        'mobile_service_th',
        'mobile_service_en',
        'wifi_service_th',
        'wifi_service_en',
        'fixed_line_service_th',
        'fixed_line_service_en',
        'device_service_th',
        'device_service_en',
        'other_service_th',
        'other_service_en',
        'privilege_content_th',
        'privilege_content_en',
        'privilege_mobile_th',
        'privilege_mobile_en',
        'privilege_wifi_th',
        'privilege_wifi_en',
        'privilege_premium_th',
        'privilege_premium_en',
        'privilege_device_th',
        'privilege_device_en',
        'privilege_other_th',
        'privilege_other_en',
        'internet_per_Mbps',
        'promotion_condition_th',
        'promotion_condition_en',
        'promotion_link_url',
        'promotion_banner'
    ],
    broadband_schema_th : [
        'รหัสรายการส่งเสริมการขาย',
        'ชื่อรายการส่งเสริมการขาย (ภาษาไทย)',
        'ชื่อรายการส่งเสริมการขาย (ภาษาอังกฤษ)',
        'ประเภทเทคโนโลยีของการให้บริการ',
        'ชนิดของรายการส่งเสริมการขาย',
        'วันเริ่มต้นของการเสนอขาย',
        'วันสิ้นสุดของการเสนอขาย',
        'วันเริ่มต้นของการให้บริการ',
        'ว้นสิ้นสุดของการให้บริการ',
        'สถานะการให้บริการ',
        'ค่าบริการรายเดือน (บาท)',
        'ความเร็วดาวน์โหลด',
        'ความเร็วอัพโหลด',
        'บริการเสริมความบันเทิง (ภาษาไทย)',
        'บริการเสริมความบันเทิง (ภาษาอังกฤษ)',
        'บริการเสริมโทรศัพท์เคลื่อนที่ (ภาษาไทย)',
        'บริการเสริมโทรศัพท์เคลื่อนที่ (ภาษาอังกฤษ)',
        'บริการเสริม WiFi/Hotspot (ภาษาไทย)',
        'บริการเสริม WiFi/Hotspot (ภาษาอังกฤษ)',
        'บริการเสริม Fixed Line (ภาษาไทย)',
        'บริการเสริม Fixed Line (ภาษาอังกฤษ)',
        'บริการเสริมอุปกรณ์อื่น ๆ (ภาษาไทย)',
        'บริการเสริมอุปกรณ์อื่น ๆ (ภาษาอังกฤษ)',
        'บริการเสริมอื่น ๆ (ภาษาไทย)',
        'บริการเสริมอื่น ๆ (ภาษาอังกฤษ)',
        'สิทธิพิเศษความบันเทิง (ภาษาไทย)',
        'สิทธิพิเศษความบันเทิง (ภาษาอังกฤษ)',
        'สิทธิพิเศษโทรศัพท์เคลื่อนที่ (ภาษาไทย)',
        'สิทธิพิเศษโทรศัพท์เคลื่อนที่ (ภาษาอังกฤษ)',
        'สิทธิพิเศษ WiFi (ภาษาไทย)',
        'สิทธิพิเศษ WiFi (ภาษาอังกฤษ)',
        'สิทธิพิเศษพรีเมียม (ภาษาไทย)',
        'สิทธิพิเศษพรีเมียม (ภาษาอังกฤษ)',
        'สิทธิพิเศษอุปกรณ์อื่น ๆ (ภาษาไทย)',
        'สิทธิพิเศษอุปกรณ์อื่น ๆ (ภาษาอังกฤษ)',
        'สิทธิพิเศษอื่น ๆ (ภาษาไทย)',
        'สิทธิพิเศษอื่น ๆ (ภาษาอังกฤษ)',
        'อัตราค่าบริการต่อหน่วย (บาท/Mbps)',
        'ข้อกำหนดและเงื่อนไขแพ็กเกจ (ภาษาไทย)',
        'ข้อกำหนดและเงื่อนไขแพ็กเกจ (ภาษาอังกฤษ)',
        'ลิงก์เว็บไซต์ หรือลิงก์รายการส่งเสริมการขาย',
        'ลิงก์รูปโฆษณาหรือรูปรายการส่งเสริมการขาย'
    ]
};
const actions = {
    async get_provider_id({commit}){
        let userinfo = await JSON.parse(Cookie.get('user_nbtc'));
        if (userinfo.provider_id !== null) {
            commit('SET_PROVIDER_ID',userinfo.provider_id)
            commit('SET_USER_ID', userinfo.admin_id)
        } else {
            MessageBox.confirm('ไม่พบ Company Provider ID', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async get_user_info({commit}){
        let result = await Manage_internet_service.get_user_info()
        if(result.status === 200){
            commit('SET_PROVIDER_ID',result.data.result[0].company_provider_id)
            commit('SET_PROVIDER_TYPE',result.data.result[0].provider_type)
            commit('SET_PROVIDER_NAME',result.data.result[0].provider_name)
        }else{
            MessageBox.confirm(result.message, 'ไม่พบข้อมูลผู้ใช้งาน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async add_promotion({ commit }, data) {
        commit('SET_LOADING', true)
        let result = await Manage_internet_service.add_promotion(data)
        let regex = /Operator\/Manage_internet/
        let path = regex.test(router.currentRoute.path) ? 'Operator_Manage_internet' : 'Manage_internet'
        if (result.status === 200) {
            commit('SET_LOADING', false)
            MessageBox.confirm('จัดเก็บข้อมูลเรียบร้อย', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                router.push({ name: path })
            }).catch(() => {
                router.push({ name: path })
            })
        } else {
            commit('SET_LOADING', false)
            MessageBox.confirm(result.data, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async edit_promotion({ state }, data) {
        let result = await Manage_internet_service.editPromotion(data);
        if (result.status === 200) {
            MessageBox.confirm('แก้ไขข้อมูลเรียบร้อย', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                let regex = /Operator\/Manage_internet/
                let path = regex.test(router.currentRoute.path) ? 'Operator_Manage_internet' : 'Manage_internet'
                router.push({ name: path })            
            })
        } else {
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async delete_promotion({commit}, row_info){
        let result = await Manage_internet_service.deletePromotion(row_info)
        if(result.status === 200){
            commit('REMOVE_PROMOTION',row_info)
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async get_all({commit},data){
        let result = await Manage_internet_service.getAll(data)
        if(result.status === 200){
            commit('FETCH_TABLE', result)
            commit('COUNTING', result.data.result[0].total)
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async getPromotionById({commit,state}, id){
        let result = await Manage_internet_service.getPromotionById(id)
        if(result.status === 200){
            state.details = result.data.result[0]
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async analyzeFile({commit}, formdata){
        commit('SET_LOADING',true)
        router.push({name : 'Confirm_promotion_internet'})
        let result = await Manage_internet_service.analyzeFile(formdata)
        if(result.status === 200){
            commit('PREPARE_TABLE',result.data.promotions)
            commit('SET_FILE_PATH_AND_TYPE',{ type : result.data.type , path : result.data.path})
            commit('ERR_ROWS',result.data.errs)
            commit('MISSING_ROWS',result.data.missings)
            commit('PICK_MONTH',result.data.month)
            let path = formdata.path ? formdata.path : 'Operator_Manage_internet'
            commit('SET_FORWARD_PATH', path)
            commit('SET_MONTH_TITLE',result.data.month)
            commit('SET_PREVIEW_DATA', {
                'count' : result.data.count,
                'average' : result.data.average
            })
            commit('SET_LOADING',false)
        }else{
            console.err(result.data)
            MessageBox.confirm('อัปโหลดไฟล์ไม่สำเร็จ กรุณาติดต่อเจ้าหน้าที่', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            }).then(()=>{
                router.push({name: 'Add_uploadsave'})
            }).catch(()=>{
                router.push({name: 'Add_uploadsave'})
            })
        }
    },

    async confirmUpload({commit,state}){
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        commit('SET_LOADING',true)
        let result = await Manage_internet_service.insertFromFile({
            path : state.file_path,
            type : state.file_type,
            missings : state.missings,
            month : state.monthly
        })
        if(result.status === 200){
            loadingInstance.close()
            MessageBox.confirm('จัดเก็บข้อมูลเรียบร้อย', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                let regex = /Operator\/Manage_internet/
                let path = regex.test(router.currentRoute.path) ? 'Operator_Manage_internet' : 'Manage_internet'
                if(state.forward_path == 'Add_uploadsave'){
                    path = 'Upload_saveMonthly'
                }
                router.push({ name: path })
            })
        }else{
            loadingInstance.close()
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async cancelUpload({state}){
        Manage_internet_service.setUnlinkFile(state.file_path)
        router.push({name : state.forward_path})
    },

    async getHistory({commit, state}, params){
        let result = await Manage_internet_service.getHistory(params)
        if(result.status === 200){
            if(result.data.diffs.length>0){
                commit('HISTORIES',result.data)
                let regex = /Operator\/Manage_internet/
                let path = regex.test(router.currentRoute.path) ? 'History_internet_operator' : 'History_internet'
                router.push({ name: path })
            }else{
                MessageBox.confirm('ไม่พบประวัติการแก้ไข', 'แจ้งเตือน', {
                    confirmButtonText: 'ตกลง',
                    showCancelButton: false,
                    type: 'warning'
                })
            }
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async search_promotion({commit,state}, formInfo){
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let userinfo = JSON.parse(Cookie.get('user_nbtc'))
            formInfo.provider_id = userinfo.provider_id ? userinfo.provider_id : formInfo.provider_id
        let result = await Manage_internet_service.findPromotion(formInfo)
        if(result.status === 200){
            result.recent = state.recent ? state.recent : await Manage_internet_service.getRecentMissingRow(formInfo)
            commit('RECENT_ROW',result.recent)
            commit('FETCH_TABLE',result)
            setTimeout(function(){ loadingInstance.close() }, 250);
        }else{
            setTimeout(function(){ loadingInstance.close() }, 250);
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async searchPopularPromotion({commit,state}, formInfo){
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        if(formInfo.month_year){
            let start = moment(formInfo.month_year).format('YYYY-MM-DD');
            let end = moment(formInfo.month_year).add(1, 'M');
            end = moment(end).subtract(1, 'd').format('YYYY-MM-DD');
            formInfo.dateRange[0] = start;
            formInfo.dateRange[1] = end;
        } else {
            let start = moment(formInfo.dateRange[0]).date(1).format('YYYY-MM-DD');
            let end = moment(start).add(1, 'M');
            end = moment(end).subtract(1, 'd').format('YYYY-MM-DD');
            formInfo.dateRange[0] = start;
            formInfo.dateRange[1] = end;
        }
        let getter = await Manage_internet_service.get_provider_id()
        let provider_id = state.provider_id ? state.provider_id : getter.data.result[0].company_provider_id
            formInfo.provider_id = formInfo.provider_id ? formInfo.provider_id : provider_id
        let result = await Manage_internet_service.searchPopularPromotion(formInfo)
        if(result.status === 200){
            result.recent = state.recent ? state.recent : await Manage_internet_service.getRecentMissingRow(formInfo)
            commit('RECENT_ROW',result.recent)
            commit('FETCH_TABLE',result)
            setTimeout(function(){ loadingInstance.close() }, 250);
        }else{
            setTimeout(function(){ loadingInstance.close() }, 250);
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async get_monthly_regulate({commit}, formInfo){
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let userinfo = await Manage_internet_service.get_user_info()
        let json_cookie = JSON.parse(Cookie.get('user_nbtc'));
        let filter = formInfo ? formInfo : {provider_id : json_cookie.provider_id}
            filter.provider_id = json_cookie.provider_id == null ? formInfo.provider_id : json_cookie.provider_id
        if(formInfo && Object.keys(formInfo).includes('month')){
          filter.month = formInfo.month ?  moment(formInfo.month).format('YYYY-MM-DD') : null
        }
        filter.provider_type = userinfo.data.result[0].provider_type == null ? formInfo.provider_type : userinfo.data.result[0].provider_type
        let result = await Manage_internet_service.getMonthlyRegulate(filter)
        if(result.status === 200){
            commit('MONTHLY_TABLE',result.data)
            commit('MONTHLY_HISTORY',result.data)
            let total = result.data[0] ? result.data[0].total : 0
            commit('COUNTING',total)
            setTimeout(function(){ loadingInstance.close() }, 10);
        }else{
            setTimeout(function(){ loadingInstance.close() }, 10);
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async download_monthly_regulate({}, filename){
        Manage_internet_service.downloadMonthlyRegulate(filename)
    },

    async export_monthly_regulate({}, row){
        Manage_internet_service.exportMonthlyRegulate({
            'regulate_id' : row.regulate_id,
            'monthly_regulate' : row.monthly_regulate,
            'provider_id' : row.provider_id,
            'provider_type' : row.provider_type,
            'original_path' : row.attache_file
        })
    },

    async remove_monthly_regulate({commit}, iteminfo){
        let result = await Manage_internet_service.removeMonthlyRegulate(iteminfo)
        if(result.status == 200){
            commit('REMOVE_ROW',iteminfo)
        }else{
            MessageBox.confirm(result.data, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async get_regulate_list({commit}){
        let userinfo = await JSON.parse(Cookie.get('user_nbtc'))
        let result = await Manage_internet_service.getAvailableMonthlyRegulate({ 'provider_id' : userinfo.provider_id})
        if(result.status == 200){
            commit('SET_REGULATE_LIST', result.data)
        }else{
            MessageBox.confirm(result.data, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async create_export_data({state}){
        var tmp = []
        for(let item of state.errors){
            tmp.push({
                'แถว' : item.row,
                'รหัสรายการส่งเสริมการขาย' : state.prepares[item.row-9].promotion_code,
                'ชื่อคอลัมน์' : state.broadband_schema_th[item.col],
                'ข้อมูล' : state.prepares[item.row-9][state.broadband_schema_en[item.col]],
                'คำอธิบาย' : item.detail || `พบการเปลี่ยนแปลงข้อมูล
ข้อมูลเดิม : ${item.old}
ข้อมูลใหม่ : ${item.new}`,
            })
        }
        return tmp
    },

    async set_edit_promotion_detail({commit}, revision_id){
        let result = await Manage_internet_service.getPromotionByRevision({revision_id})
        if(result.status === 200){
            if(result.data.length){
                let item = result.data[0]
                item.start_sale_date = item.start_sale_date ? moment(item.start_sale_date).add(543,'Y').format('DD/MM/YYYY') : null
                item.end_sale_date = item.end_sale_date ? moment(item.end_sale_date).add(543,'Y').format('DD/MM/YYYY') : null
                item.start_service_date = item.start_service_date ? moment(item.start_service_date).add(543,'Y').format('DD/MM/YYYY') : null
                item.end_service_date = item.end_service_date ? moment(item.end_service_date).add(543,'Y').format('DD/MM/YYYY') : null
                commit('SET_EDIT_ROW', item)
                router.push({ name: "Edit_promotion_internet" })
            }else{
                MessageBox.confirm('ไม่พบข้อมูล', 'แจ้งเตือน', {
                    confirmButtonText: 'ตกลง',
                    showCancelButton: false,
                    type: 'warning'
                })
            }
        }else{
            alert(result.data)
        }
    }

};

const mutations = {
    SET_PROVIDER_ID(state,id){
        state.provider_id = id
    },
    SET_PROVIDER_TYPE(state,type){
        state.provider_type = type
    },
    SET_PROVIDER_NAME(state,name){
        state.provider_name = name
    },
    SET_USER_ID(state,id){
        state.user_id = id
    },
    FETCH_TABLE(state,obj){
        let promotion = obj.data.result
        let recent = obj.recent.data
            recent = recent.filter(item => item.diff > -5)
            recent = recent.map(item => item = item.promotion_code)
        state.lists = []
        let today = moment()
        promotion.forEach(function(val){
            val.disabled = (moment(val.end_service_date).diff(today,'days') < 0)
            if(recent.includes(val.promotion_code)){ 
                val.disabled = false
            }
            val.created_at = moment(val.created_at).add(543, 'y').format('DD/MM/YYYY') != 'Invalid date' ? moment(val.created_at).add(543, 'y').format('DD/MM/YYYY') : ''
            val.start_sale_date = moment(val.start_sale_date).add(543, 'y').format('DD/MM/YYYY') != 'Invalid date' ? moment(val.start_sale_date).add(543, 'y').format('DD/MM/YYYY') : ''
            val.end_sale_date = moment(val.end_sale_date).add(543, 'y').format('DD/MM/YYYY') != 'Invalid date' ? moment(val.end_sale_date).add(543, 'y').format('DD/MM/YYYY') : ''
            val.start_service_date = moment(val.start_service_date).add(543, 'y').format('DD/MM/YYYY') != 'Invalid date' ? moment(val.start_service_date).add(543, 'y').format('DD/MM/YYYY') : ''
            val.end_service_date = moment(val.end_service_date).add(543, 'y').format('DD/MM/YYYY') != 'Invalid date' ? moment(val.end_service_date).add(543, 'y').format('DD/MM/YYYY') : ''
            val.deleted_at = val.deleted_at ? moment(val.deleted_at).add(543,'Y').format('DD/MM/YYYY') : ''
            state.lists.push(val)
        })
        state.total = promotion[0] ? promotion[0].total : 0
    },
    COUNTING(state,num){
        state.total = null
        state.total = num
    },
    REMOVE_PROMOTION(state,item_info){
        let index = state.lists.findIndex(item => item.promotion_id == item_info.promotion_id)
        state.lists.splice(index, 1)
        state.total = state.total - 1
    },
    PREPARE_TABLE(state,rows){  
        state.prepares = rows
    },
    ERR_ROWS(state, data){
        state.errors = data
    },
    HISTORIES(state, data){
        state.histories = data.diffs
        state.name = data.promotion_name
    },
    MISSING_ROWS(state, data){
        state.missings = Object.keys(data)
    },
    STORE_FORM(state, form){
        state.formdata = form
    },
    SET_FILE_PATH_AND_TYPE(state, file_info){
        state.file_path = file_info.path
        state.file_type = file_info.type
    },
    SET_DETAILS(state, row){
        row.start_sale_date     = moment(row.start_sale_date,'DD/MM/YYYY').isValid() ? moment(row.start_sale_date,'DD/MM/YYYY').toDate() : null
        row.end_sale_date       = moment(row.end_sale_date, 'DD/MM/YYYY').isValid() ? moment(row.end_sale_date,'DD/MM/YYYY').toDate() : null
        row.start_service_date  = moment(row.start_service_date,'DD/MM/YYYY').isValid() ? moment(row.start_service_date,'DD/MM/YYYY').toDate() : null
        row.end_service_date    = moment(row.end_service_date,'DD/MM/YYYY').isValid() ? moment(row.end_service_date,'DD/MM/YYYY').toDate() : null
        state.details = row   
    },
    PICK_MONTH(state, month){
        state.monthly = moment(month).format('YYYY-MM-DD')
    },
    MONTHLY_TABLE(state, data){
        for(let item of data){
            item.provider_type_th = item.provider_type == 'mobile' ? 'โทรศัพท์เคลื่อนที่' : 'อินเทอร์เน็ตความเร็วสูงประจำที่'
            item.status = moment(item.monthly_regulate).add(1,'M').add(14,'d') < moment(item.created_at) ? 'ล่าช้า' : 'ปกติ' 
            item.monthly_regulate = moment(item.monthly_regulate).add(543,'Y').format('MM/YYYY')
            item.created_at = moment(item.created_at).add(543,'Y').format('DD/MM/YYYY HH:mm')
        }
        state.prepares = data
        state.total = data[0] ? data[0].total : 0
    },
    MONTHLY_HISTORY(state, data){
        state.histories = data.map(item => item.monthly_regulate)
    },
    RECENT_ROW(state, obj){
        state.recent = obj
    },
    SET_FORWARD_PATH(state, path){
        state.forward_path = path
    },
    SET_LOADING(state,status){
        state.loading = status
    },
    SET_MONTH_TITLE(state, month){
        state.month_title = month_th[moment(month).month()]+' ปี พ.ศ. '+moment(month).add(543,'Y').format('YYYY')
    },
    SET_PREVIEW_DATA(state, data){
        state.preview_data.count = data.count
        state.preview_data.average = {
            'FTTx' : data.average['fttx'] ? data.average['fttx'].toFixed(3) : '',
            'ADSL' : data.average['adsl'] ? data.average['adsl'].toFixed(3) : '',
            'VDSL' : data.average['vdsl'] ? data.average['vdsl'].toFixed(3) : '',
            'WiFi' : data.average['wifi'] ? data.average['wifi'].toFixed(3) : '',
            'VAS' : data.average['vas'] ? data.average['vas'].toFixed(3) : '',
            'ทั้งหมด' : data.average['total'] ? data.average['total'].toFixed(3) : ''
        }
        state.preview_data.percent['fttx'] = data.count['fttx'] > 0 ? (data.count['fttx']/data.count['total']*100).toFixed(2) : 0
        state.preview_data.percent['adsl'] = data.count['adsl'] > 0 ? (data.count['adsl']/data.count['total']*100).toFixed(2) : 0
        state.preview_data.percent['vdsl'] = data.count['vdsl'] > 0 ? (data.count['vdsl']/data.count['total']*100).toFixed(2) : 0
        state.preview_data.percent['wifi'] = data.count['wifi'] > 0 ? (data.count['wifi']/data.count['total']*100).toFixed(2) : 0
        state.preview_data.percent['vas'] = data.count['vas'] > 0 ? (data.count['vas']/data.count['total']*100).toFixed(2) : 0
    },
    SET_EDIT_ROW(state, data){
        data.start_sale_date = data.start_sale_date ? moment(data.start_sale_date,'DD/MM/YYYY').subtract(543,'Y').format('YYYY-MM-DD') : null
        data.end_sale_date = data.end_sale_date ? moment(data.end_sale_date,'DD/MM/YYYY').subtract(543,'Y').format('YYYY-MM-DD') : null
        data.start_service_date = data.start_service_date ? moment(data.start_service_date,'DD/MM/YYYY').subtract(543,'Y').format('YYYY-MM-DD') : null
        data.end_service_date = data.end_service_date ? moment(data.end_service_date,'DD/MM/YYYY').subtract(543,'Y').format('YYYY-MM-DD') : null
        state.details = data
    },
    SET_ACTIVE_STATUS(state, promotion_id){
        for(let i in state.lists){
            if(state.lists[i].promotion_id == promotion_id){
                state.lists[i].active_status = !state.lists[i].active_status 
            }
        }
    },
    REMOVE_ROW(state, iteminfo){
        let item_index = state.prepares.findIndex(x => x.regulate_id == iteminfo.regulate_id)
        state.prepares.splice(item_index, 1)
        state.total = state.total - 1
    },
    UPDATE_CR_STATUS(state, item){
        let index = state.lists.findIndex(row => row.promotion_id == item.promotion_id)
        state.lists[index].cr_remark = item.cr_remark
        state.lists[index].cr_status = item.cr_status
        state.lists[index].active_status = item.active_status ? item.active_status : state.lists[index].active_status
    },
    SET_REGULATE_LIST(state, list){
        state.regulate_list = list
    }
};

export const Manage_internet = {
    namespaced: true,
    state,
    actions,
    mutations
};
